import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { getBusinessThumbnailSrc } from 'utils/businessUtils';
import {
  walkinWaitlistBusinessImage,
  walkinWaitlistBusinessSummaryContent,
  walkinWaitlistBusinessSummaryRoot,
} from 'components/business/walkin-waitlist/walkinWaitlistCssDefs';
import React from 'react';

interface Props {
  business: consumer.IBusinessConfig;
}

const WalkinWaitlistBusinessHeader: React.FunctionComponent<Props> = ({ business }) => {
  const businessSummary = business
    ? [business.cuisines, business.priceRange].filter(Boolean).join(' · ')
    : '';
  const imgSrc = getBusinessThumbnailSrc(business, { height: 80, width: 80 });

  return (
    <section css={walkinWaitlistBusinessSummaryRoot}>
      {imgSrc && (
        <img
          css={walkinWaitlistBusinessImage}
          loading="eager"
          src={imgSrc}
          alt={business.name || ''}
        />
      )}
      <section css={walkinWaitlistBusinessSummaryContent}>
        <Typography component="h3" variant="heading03">
          {business.name}
        </Typography>
        <Typography variant="body02">{businessSummary}</Typography>
      </section>
    </section>
  );
};

export default WalkinWaitlistBusinessHeader;
